import { z } from 'zod'

export enum SegmentType {
  AFFILIATES = 'affiliate',
  INFOPRENEURS = 'infopreneur',
}

export const segmentInsightsDataSchemas = z
  .object({
    segment_type: z.enum(SegmentType),
    urls_sent_cnt: z.number(),
    leads_cnt: z.number(),
  })
  .nullable()

export type SegmentInsightsDataSchemaType = z.infer<typeof segmentInsightsDataSchemas>
